import React, { useState, useEffect } from 'react';  // Add useEffect
import { motion } from 'framer-motion';
import { IoAddOutline, IoReceiptOutline } from 'react-icons/io5';
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDelete } from "react-icons/md";
import { toast } from 'react-toastify';
import axios from 'axios';
import { useUser } from '../context/UserContext';  // Add this import
import { useCustomDialog } from '../context/DialogProvider';
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { format, startOfMonth, endOfMonth, differenceInCalendarDays } from 'date-fns';
import { IoChevronBackCircle, IoChevronForwardCircle } from 'react-icons/io5';
 import {  parse } from 'date-fns';
import api from '../utils/api';
import { SlCalender } from 'react-icons/sl';




 const TIME_CONFIG = {
    FULL_DAY: { label: 'Full Day', duration: 1 },
    FIRST_HALF: { label: 'First Half', duration: 0.5 },
    SECOND_HALF: { label: 'Second Half', duration: 0.5 }
  };


function Attendance() {
  // Comp Off popup state
  const [showApplyForm, setShowApplyForm] = useState(false);
 const [newCompOff, setNewCompOff] = useState({
   onDate: '',
   duration: TIME_CONFIG.FULL_DAY.duration,
   reason: '',
   timing: 'FULL_DAY' // Must match key used in TIME_CONFIG
 });
 const [isSubmitting, setIsSubmitting] = useState(false);

  // For On Duty popup
  const [showOnDutyForm, setShowOnDutyForm] = useState(false);
  const [onDutyDate, setOnDutyDate] = useState("");
  const [onDutyLocation, setOnDutyLocation] = useState("");
  const [onDutyTiming, setOnDutyTiming] = useState("FULL_DAY");
  const [onDutyReason, setOnDutyReason] = useState("");
  const [onDutySubmitting, setOnDutySubmitting] = useState(false);
  const [totalHoursWorked, setTotalHoursWorked] = useState(0);
  const [monthlyHours, setMonthlyHours] = useState(0);
 
  const baseUrl = process.env.REACT_APP_API_URL;
  const { currentUser, loading } = useUser();
  const [attendance, setAttendance] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedMonth, setSelectedMonth] = useState(new Date());

  // Calculate days in selected month
  const daysInMonth = differenceInCalendarDays(endOfMonth(selectedMonth), startOfMonth(selectedMonth)) + 1;
  const pageSize = daysInMonth;


  const parseTime = (timeStr) => {
  try {
    if (/^\d{2}:\d{2}:\d{2}$/.test(timeStr)) {
      return format(parse(timeStr, 'HH:mm:ss', new Date()), 'hh:mm a');
    } else if (/^\d{2}:\d{2}$/.test(timeStr)) {
      return format(parse(timeStr, 'HH:mm', new Date()), 'hh:mm a');
    }
  } catch (err) {
    return '-';
  }
  return '-';
};

function formatHours(decimalHours) {
  if (!decimalHours || isNaN(decimalHours)) return '-';

  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);

  let result = '';
  if (hours > 0) result += `${hours} hr${hours > 1 ? 's' : ''}`;
  if (minutes > 0) result += ` ${minutes} min`;
  return result.trim();
}


// ✅ For Comp Off
function getCompOffTiming(row) {
  
  const hoursWorked = row.totalHoursWorked;
  const punchInHour = new Date(`1970-01-01T${row.punchInTime}`).getHours();

  if (hoursWorked >= 7) {
    return "FULL_DAY";
  } else if (hoursWorked >= 4) {
    // Normal logic
    return punchInHour < 11 ? "FIRST_HALF" : "SECOND_HALF";
  }
}



// ✅ For On Duty
function getOnDutyTiming(row) {
  if (!row.punchInTime || !row.punchOutTime || !row.totalHoursWorked) {
    return "FULL_DAY";
  }

  const hoursWorked = row.totalHoursWorked;
  const punchInHour = new Date(`1970-01-01T${row.punchInTime}`).getHours();

  if (hoursWorked >= 2) {
    // Swapped logic 🔄
    return punchInHour < 12 ? "SECOND_HALF" : "FIRST_HALF";
  } else {
    return "FULL_DAY";
  }
}




  // Fetch all attendance data for the user, then filter by month on frontend
  const fetchAttendance = async () => {
    if (!currentUser?.id) return;
    setIsLoading(true);
    try {
      // Fetch all attendance for the user (or you can optimize with a month filter if backend supports)
      const response = await api.get(`/api/daily-attendance/${currentUser.id}?size=500`);
      const allData = response.data.content || [];

     // console.log("All Attendance Data:", allData);
      // Filter for selected month
      const filtered = allData.filter(row => {
        const date = new Date(row.date);
        return date.getFullYear() === selectedMonth.getFullYear() && date.getMonth() === selectedMonth.getMonth();
      });
      
      setAttendance(filtered);
    } catch (error) {
      toast.error('Failed to fetch attendance data');
    } finally {
      setIsLoading(false);
    }
  };


  const fetchMonthlyHours = async () => {
  if (!currentUser?.id) return;
  try {
    // Note: getMonth() is 0-indexed (Jan=0), 
    // but most Java backends expect 1-indexed (Jan=1)
    const year = selectedMonth.getFullYear();
    const month = selectedMonth.getMonth() + 1; 

    const response = await api.get(`/api/daily-attendance/monthly-worked-hours`, {
      params: { 
        userId: currentUser.id, 
        year: year, 
        month: month 
      }
    });
    setMonthlyHours(response.data || 0);
  } catch (error) {
    console.error("Error fetching monthly total:", error);
  }
};

// 3. Update your useEffect to include the new fetch
useEffect(() => {
  if (!loading && currentUser?.id) {
    fetchAttendance();
    fetchMonthlyHours(); // <--- Add this here
  }
  // eslint-disable-next-line
}, [currentUser?.id, loading, selectedMonth]);



  useEffect(() => {
    if (!loading && currentUser?.id) {
      fetchAttendance();
    }
    // eslint-disable-next-line
  }, [currentUser?.id, loading, selectedMonth]);

  // Helper for status color
  function getStatusProps(status) {
    const normalized = (status || "").toString().trim();
    switch (normalized) {
      case "Present":
        return { label: "Present", color: "bg-green-100 text-green-700" };
      case "OnLeave":
        return { label: "On Leave", color: "bg-blue-100 text-blue-700" };
      case "Absent":
        return { label: "Absent", color: "bg-red-100 text-red-700" };
      case "HalfDay":
        return { label: "Half Day", color: "bg-gradient-to-r from-green-100 to-red-100 text-orange-700" };
      case "Late":
        return { label: "Late", color: "bg-yellow-100 text-orange-700" };
      case "EarlyOut":
        return { label: "Early Out", color: "bg-yellow-100 text-purple-700" };
      case "Weekend":
        return { label: "Weekend", color: "bg-slate-100 text-slate-700" };
      case "Holiday":
        return { label: "Holiday", color: "bg-slate-100 text-teal-700" };
        
      case "CompOff":
        return { label: "Comp off", color: "bg-indigo-100 text-indigo-700" };

       case "HalfCompOff":
        return { label: "Comp off", color: "bg-indigo-100 text-indigo-700" };

      
        case "CompOffApply":
        return { label: "Comp off apply", color: "bg-indigo-100 text-indigo-700 animate-pulse" };


        case "OnDuty":
        return { label: "On Duty", color: "bg-teal-100 text-indigo-700" };


        case "PresentAndOnDuty":
        return { label: "Present & OD", color: "bg-gradient-to-r from-green-100 to-teal-100 text-green-700" };

        case "AbsentAndOnDuty":
        return { label: "Half OnDuty", color: "bg-gradient-to-r from-red-100 to-teal-100 text-red-700" };




        case "OndutyAndSickLeave":
        return { label: "OD & Half SL", color: "bg-gradient-to-r from-teal-100 to-blue-100 text-teal-700" };

        case "OnDutyAndEanredLeave":
        return { label: "OD & Half EL", color: "bg-gradient-to-r from-teal-100 to-blue-100 text-teal-700" };

        case "OndutyAndCompOffLeave":
        return { label: "OD & Half COL", color: "bg-gradient-to-r from-teal-100 to-blue-100 text-teal-700" };




        case "EarnedLeave":
        return { label: "Earned Leave", color: "bg-blue-100 text-blue-700" };

        case "SickLeave":
        return { label: "Sick Leave", color: "bg-blue-100 text-blue-700" };

        case "CompOffLeave":
        return { label: "Compoff Leave", color: "bg-blue-100 text-blue-700" };


        case "PresentAndSickLeave":
        return { label: "Half Sick Leave", color: "bg-gradient-to-r from-green-100 to-blue-100 text-green-700" };

         case "PresentAndEarnedLeave":
        return { label: "Half Earned Leave", color: "bg-gradient-to-r from-green-100 to-blue-100 text-green-700" };

        case "PresentAndComOffLeave":
        return { label: "Half Compoff Leave", color: "bg-gradient-to-r from-green-100 to-blue-100 text-green-700" };



        case "AbsentAndSickLeave":
        return { label: "Half Sick Leave", color: "bg-gradient-to-r from-red-100 to-blue-100 text-red-700" };

         case "AbsentAndEarnedLeave":
        return { label: "Half Earned Leave", color: "bg-gradient-to-r from-red-100 to-blue-100 text-red-700" };

        case "AbsentAndComOffLeave":
        return { label: "Half Compoff Leave", color: "bg-gradient-to-r from-red-100 to-blue-100 text-red-700" };


      default:
        return { label: normalized, color: "bg-gray-100 text-gray-800" };
    }
  }

  return (
    <div className="sm:p-6 sm:mt-auto mt-8 am:mb-auto mb-20 w-full mx-auto">
      <motion.div
              className="flex sm:justify-between justify-center  items-center mb-6 bg-slate-200 rounded-2xl p-6"
              transition={{ duration: 0.4, type: "spring" }}
            >
            <div className='flex items-center justify-center gap-4 text-xl xs:text-2xl  font-bold truncate hidden sm:flex'>
               <div className="p-2 rounded-lg bg-slate-700 text-slate-100" ><SlCalender/></div>
               <h2 className="">Attendance History</h2>
            </div>


        
        <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6 gap-4">

          <div className="flex flex-row items-center gap-6 mb-2 sm:mb-0 bg-white px-4 py-2 rounded-xl border border-slate-200 shadow-sm">
          <div>
          <p className="">
            Total Hours <spam className="font-bold bg-slate-200 px-2 py-1 rounded-full">{formatHours(monthlyHours)}</spam>
          </p>
          </div>
         </div>
          
        <div className="inline-flex items-center divide-x divide-slate-200 bg-white px-4 py-2 rounded-xl border border-slate-200 shadow-sm">

          
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              className="pr-4 text-slate-500 hover:text-slate-700 focus:outline-none transition-colors"
              onClick={() => setSelectedMonth(prev => new Date(prev.getFullYear(), prev.getMonth() - 1, 1))}
              aria-label="Previous Month"
            >
              <IoChevronBackCircle className="text-2xl" />
            </motion.button>
            
            <motion.div
              key={selectedMonth.getTime() + 'style3'}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="px-6"
            >
              <span className="font-semibold text-slate-700 text-base select-none">
                {format(selectedMonth, 'MMMM yyyy')}
              </span>
            </motion.div>
            
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              className="pl-4 text-slate-500 hover:text-slate-700 focus:outline-none transition-colors"
              onClick={() => setSelectedMonth(prev => new Date(prev.getFullYear(), prev.getMonth() + 1, 1))}
              aria-label="Next Month"
            >
              <IoChevronForwardCircle className="text-2xl" />
            </motion.button>
          </div>
          </div>

        
      </motion.div>

      {/* Calendar Card Grid View */}
      <motion.div
        className="bg-white rounded-2xl shadow-md p-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        
        {isLoading ? (
          <div className="flex justify-center items-center py-16">
            <svg
              className="animate-spin h-10 w-10 text-slate-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8z"
              ></path>
            </svg>
          </div>
        ) : attendance.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 xl:grid-cols-7 gap-6 w-full">
            {attendance.map((row, index) => {
              const { label, color } = getStatusProps(row.status);
              // Card background color based on status
              let cardBg = "bg-gradient-to-br from-slate-50 to-slate-100";
              // Modern card style: soft shadow, rounded corners, subtle hover, more padding, left-aligned, clear separation, colored status pill, vibrant icons
              return (
                <div
                  key={row.id}
  className={`flex flex-col border border-slate-200 rounded-xl p-3 min-h-[120px] w-full max-w-[150px] mx-auto shadow-md hover:shadow-lg transition-all duration-200 group cursor-pointer items-center justify-center ${color}`}
  style={{ aspectRatio: '1 / 1' }}
                  onClick={() => {
                    const status = (row.status || "").toString().trim();
                    if (status === "HalfDay" || status === "Absent" || status === "AbsentAndOnDuty" || status === "AbsentAndSickLeave" || status === "AbsentAndEarnedLeave" || status === "AbsentAndComOffLeave") {
                      setOnDutyDate(row.date);
                      setOnDutyLocation("");
                      setOnDutyTiming(getOnDutyTiming(row));
                      setOnDutyReason("");
                      setShowOnDutyForm(true);
                    } 
                    else if (status === "CompOffApply") {
                       setNewCompOff({
                          onDate: row.date,     // pre-fill date
                          reason: '',
                          timing: getCompOffTiming(row),
                          duration: TIME_CONFIG.FULL_DAY.duration
                       });
                      setShowApplyForm(true);  // show the form/modal
                    }
                  }}
                >
            
            
                
<div className="flex flex-col items-center mb-0">
  <span className="text-xl font-extrabold text-slate-800 leading-none">
    {format(new Date(row.date), "dd")}
  </span>
  <span className="text-xs font-medium text-slate-500">
    {format(new Date(row.date), "EEEE")}  {/* Use "EEEE" for full name */}
  </span>
  <span className={`mt-0.5 px-1.5 py-0.5 rounded-full text-xs font-bold tracking-wide border border-slate-200 bg-white shadow-sm ${color?.split(' ')[1] || ''}`}>
    {label}
  </span>
</div>

<div className="flex flex-col gap-0.5 mt-0.5 w-full">
  {/* Punch In */}
  <div className="flex items-center gap-0.5 justify-center">
    <span className="flex items-center justify-center w-4 h-4 bg-blue-50 rounded-full">
      <svg className="w-3 h-3 text-blue-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-2-2 2 2-2 2" />
      </svg>
    </span>
    <span className={row.punchInTime ? "text-slate-700 font-semibold text-xs" : "text-slate-400 text-xs"}>
      {row.punchInTime ? parseTime(row.punchInTime) : '-'}
    </span>
  </div>

  {/* Punch Out */}
  <div className="flex items-center gap-0.5 justify-center">
    <span className="flex items-center justify-center w-4 h-4 bg-pink-50 rounded-full">
      <svg className="w-3 h-3 text-pink-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12H9m2-2-2 2 2 2" />
      </svg>
    </span>
    <span className={row.punchOutTime ? "text-slate-700 font-semibold text-xs" : "text-slate-400 text-xs"}>
      {row.punchOutTime ? parseTime(row.punchOutTime) : '-'}
    </span>
  </div>

  {/* Worked Hours */}
  <div className="flex items-center gap-0.5 justify-center">
    <span className="flex items-center justify-center w-4 h-4 bg-green-50 rounded-full">
      <svg className="w-3 h-3 text-green-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l2.5 2.5" />
      </svg>
    </span>
    <span className={row.totalHoursWorked ? "text-slate-700 font-semibold text-xs" : "text-slate-400 text-xs"}>
  {row.totalHoursWorked ? formatHours(row.totalHoursWorked) : '-'}
</span>

    </div>
  </div>
                </div>



              );
            })}


            {/* Comp Off Popup Modal */}
            {showApplyForm && (
  <div 
    className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50"
    onClick={() => setShowApplyForm(false)}
  >
    <motion.div 
      className="bg-white p-6 rounded-2xl max-w-md w-full mx-4 shadow-xl"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      onClick={e => e.stopPropagation()}
    >
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-bold text-slate-800">Apply Comp Off</h3>
        <button
          onClick={() => setShowApplyForm(false)}
          className="text-slate-400 hover:text-slate-600"
        >
          ✕
        </button>
      </div>
      <form
        className="space-y-4"
        onSubmit={async (e) => {
          e.preventDefault();
          setIsSubmitting(true);
          try {
            await api.post(`/api/compoffs/apply?employeeId=${currentUser?.id}`, {
              onDate: newCompOff.onDate,
              reason: newCompOff.reason,
              timing: newCompOff.timing,
              duration: TIME_CONFIG[newCompOff.timing]?.duration || 0
            });
            setNewCompOff({
                          onDate: '',     // pre-fill date
                          reason: '',
                          timing: 'FULL_DAY',
                          duration: TIME_CONFIG.FULL_DAY.duration
                       });
            toast.success('Comp Off request submitted successfully');
            setShowApplyForm(false);
          } catch (error) {
            toast.error('Failed to submit Comp Off request');
          } finally {
            setIsSubmitting(false);
          }
        }}
      >
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Comp Off Date</label>
          <input
            type="date"
            value={newCompOff.onDate}
            readOnly
            className="w-full border border-slate-200 rounded-lg p-2.5 bg-slate-100 cursor-not-allowed"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Timing</label>
          <select
  value={newCompOff.timing}
  onChange={(e) => {
    const selectedKey = e.target.value;
    const config = TIME_CONFIG[selectedKey];
    setNewCompOff({
      ...newCompOff,
      duration: config.duration,
      timing: selectedKey
    });
  }}
  className="w-full border border-slate-200 rounded-lg p-2.5"
  required
>
  {Object.entries(TIME_CONFIG).map(([key, config]) => (
    <option key={key} value={key}>{config.label}</option>
  ))}
</select>
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Reason</label>
          <textarea
            value={newCompOff.reason}
            onChange={(e) => setNewCompOff({ ...newCompOff, reason: e.target.value })}
            className="w-full border border-slate-200 rounded-lg p-2.5"
            rows="3"
            required
          ></textarea>
        </div>
        <div className="flex justify-end gap-3 pt-4">
          <button
            type="button"
            onClick={() => setShowApplyForm(false)}
            className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-slate-800"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className={`px-4 py-2 text-sm font-medium bg-slate-800 text-white rounded-full hover:bg-slate-700 min-w-[100px] ${isSubmitting ? 'opacity-60 cursor-not-allowed' : ''}`}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </form>
    </motion.div>
  </div>
)}



            {/* On Duty Popup Form (moved outside map) */}
            {showOnDutyForm && (
              <div 
                className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50"
                onClick={() => setShowOnDutyForm(false)}
              >
                <motion.div 
                  className="bg-white p-6 rounded-2xl max-w-md w-full mx-4 shadow-xl"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  onClick={e => e.stopPropagation()}
                >
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-bold text-slate-800">On Duty Application</h3>
                    <button
                      onClick={() => setShowOnDutyForm(false)}
                      className="text-slate-400 hover:text-slate-600"
                    >
                      ✕
                    </button>
                  </div>
                  <form className="space-y-4" onSubmit={async (e) => {
                    e.preventDefault();
                    setOnDutySubmitting(true);
                    try {
                      await api.post(`/api/onduty/apply?employeeId=${currentUser?.id}`, {
                        onDate: onDutyDate,
                        location: onDutyLocation,
                        duration: TIME_CONFIG[onDutyTiming].duration,
                        reason: onDutyReason,
                        timing: onDutyTiming
                      });
                      setOnDutyDate("");
                      setOnDutyLocation("");
                      setOnDutyTiming("FULL_DAY");
                      setOnDutyReason("");
                      setShowOnDutyForm(true);
                      toast.success('On Duty request submitted successfully');
                      setShowOnDutyForm(false);
                    } catch (error) {
                      toast.error('Failed to submit On Duty request');
                    } finally {
                      setOnDutySubmitting(false);
                    }
                  }}>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">On Duty Date</label>
                      <input
                        type="date"
                        value={onDutyDate}
                        readOnly
                        className="w-full border border-slate-200 rounded-lg p-2.5 bg-slate-100 cursor-not-allowed"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Location</label>
                      <input
                        type="text"
                        value={onDutyLocation}
                        onChange={e => setOnDutyLocation(e.target.value)}
                        className="w-full border border-slate-200 rounded-lg p-2.5"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Timing</label>
                      <select
                        value={onDutyTiming}
                        onChange={e => setOnDutyTiming(e.target.value)}
                        className="w-full border border-slate-200 rounded-lg p-2.5"
                        required
                      >
                        {Object.entries(TIME_CONFIG).map(([key, config]) => (
                          <option key={key} value={key}>{config.label}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Reason</label>
                      <textarea
                        value={onDutyReason}
                        onChange={e => setOnDutyReason(e.target.value)}
                        className="w-full border border-slate-200 rounded-lg p-2.5"
                        rows="3"
                        required
                      ></textarea>
                    </div>
                    <div className="flex justify-end gap-3 pt-4">
                      <button
                        type="button"
                        onClick={() => setShowOnDutyForm(false)}
                        className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-slate-800"
                        disabled={onDutySubmitting}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        disabled={onDutySubmitting}
                        className={`px-4 py-2 text-sm font-medium bg-slate-800 text-white rounded-full hover:bg-slate-700 min-w-[100px] ${onDutySubmitting ? 'opacity-60 cursor-not-allowed' : ''}`}
                      >
                        {onDutySubmitting ? 'Submitting...' : 'Submit'}
                      </button>
                    </div>
                  </form>
                </motion.div>
              </div>
            )}
          </div>
        ) : (
          <div className="text-center text-slate-400 py-16 text-lg">No attendance data found</div>
        )}
        {/* Pagination removed: only one page per month, navigation is by month */}
      </motion.div>

      {/* Mobile View */}

      {/* You can add a similar mobile view as OnDuty if needed */}
    </div>
  );
}

export default Attendance;